<ng-container *ngIf="isServiceError() && isServiceErrorSource(); then errorContainer else entriesContainer"></ng-container>

<ngx-spinner 
    name="index-spinner"
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="ball-clip-rotate"
>
    <p aria-live="polite" style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<ng-template #entriesContainer>
    <div *ngIf="anyEntriesToDisplay()" class="row">
        <app-icon-legend [thesaurusId]="thesaurus?.id ?? ''"></app-icon-legend>
    </div>

    <div *ngIf="anyEntriesToDisplay()" class="row explode-major-col-wrapper">
        <div [ngClass]="{'col-12': !isMajorOrExplode(), 'col-9': 'isMajorOrExplode()'}">
             {{getRelationalTextKey() | i18next}}
        </div>
        <div *ngIf="isMajor() || isExplode()" class="col-3 explode-major-col-label">
            <span *ngIf="isExplode()">Explode</span>
            <span *ngIf="isMajor()">Major</span>
        </div>
        <div *ngIf="displaySuggestedTermsMsg()" class="col-9 sugestedTermsMsg">{{suggestedTermsMessage()}}</div>
    </div>

    <div *ngIf="!anyEntriesToDisplay()" class="row explode-major-col-wrapper">
        <div *ngIf="noResults()" class="col-9 noResultsMsg"><strong>{{'error_noresults.text' | i18next}}</strong></div>
    </div>

    <div id="termsWrapper" tabindex="-1">
        <div *ngIf="isDisplayEntriesAll; then entriesAllContainer else entriesAlphaContainer"></div>
    </div>

</ng-template>

<ng-template #entriesAllContainer>
    <div *ngIf="entriesAll">
        <div *ngFor="let entry of entriesAll; index as i">
            <app-thesaurus-entry #thesEntry [entry]=entry [notesId]="''" [collapsingNotesId]="''" [index]="i.toString()" [explode]="isExplode()" [major]="isMajor()"></app-thesaurus-entry>
        </div>
    </div>
</ng-template>

<ng-template #entriesAlphaContainer>
    <div *ngIf="entries">
        <div *ngFor="let entry of entries; index as i">
            <app-thesaurus-entry #thesEntry [entry]=entry [notesId]="''" [collapsingNotesId]="''" [index]="i.toString()" [explode]="isExplode()" [major]="isMajor()"></app-thesaurus-entry>
        </div>
    </div>
</ng-template>

<ng-template #errorContainer>
    <app-service-error id="errorMsg-Entries"></app-service-error>
</ng-template>
